export interface SettingsInterface {
  svg: string | null;
  mimetype: 'image/png' | 'image/jpeg';
  width: number | string;
  height: number | string;
  quality: number;
  outputFormat: string;
}

const SVGToImage = (settings: SettingsInterface) => {
  let _settings: SettingsInterface = {
    svg: null,
    // Usually all SVG have transparency, so PNG is the way to go by default
    mimetype: 'image/png',
    quality: 0.92,
    width: 'auto',
    height: 'auto',
    outputFormat: 'base64',
  };

  // Override default settings
  for (let key in settings) {
    (_settings as any)[key] = settings[key as keyof typeof settings];
  }

  return new Promise(function(resolve, reject) {
    let svgNode;

    // Create SVG Node if a plain string has been provided
    if (typeof _settings.svg == 'string') {
      // Create a non-visible node to render the SVG string
      let SVGContainer = document.createElement('div');
      SVGContainer.style.display = 'none';
      SVGContainer.innerHTML = _settings.svg;
      svgNode = SVGContainer.firstElementChild;
    } else {
      svgNode = _settings.svg;
    }

    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');

    let svgXml = new XMLSerializer().serializeToString(svgNode as Node);
    let svgBase64 = 'data:image/svg+xml;base64,' + btoa(svgXml);

    const image = new Image();

    image.onload = function() {
      let finalWidth, finalHeight;

      // Calculate width if set to auto and the height is specified (to preserve aspect ratio)
      if (_settings.width === 'auto' && _settings.height !== 'auto') {
        finalWidth = (image.width / image.height) * (_settings as any).height;
        // Use image original width
      } else if (_settings.width === 'auto' && image.naturalWidth) {
        finalWidth = image.naturalWidth!;
        // Use custom width
      } else {
        finalWidth = _settings.width;
      }

      // Calculate height if set to auto and the width is specified (to preserve aspect ratio)
      if (_settings.height === 'auto' && _settings.width !== 'auto') {
        finalHeight = (image.height / image.width) * (_settings as any).width;
        // Use image original height
      } else if (_settings.height === 'auto') {
        finalHeight = image.naturalHeight;
        // Use custom height
      } else {
        finalHeight = _settings.height;
      }

      // Define the canvas intrinsic size
      canvas.width = finalWidth as number;
      canvas.height = finalHeight as number;

      // Render image in the canvas
      const neverRead = context?.drawImage(
        image,
        0,
        0,
        finalWidth as number,
        finalHeight as number,
      );

      if (_settings.outputFormat == 'blob') {
        // Fullfil and Return the Blob image
        canvas.toBlob(
          function(blob) {
            resolve(blob);
          },
          _settings.mimetype,
          _settings.quality,
        );
      } else {
        // Fullfil and Return the Base64 image
        resolve(canvas.toDataURL(_settings.mimetype, _settings.quality));
      }
    };

    // Load the SVG in Base64 to the image
    image.src = svgBase64;
  });
};

export { SVGToImage };
